import { RouteComponentProps, withRouter } from 'react-router-dom';
import { DrawerState } from '../../../core/models/enum';
import { FederationDetailVm } from '../../../utils/api';
import { RouteParams } from '../../../core/models/RouteHelper';
import FederationForm from './FederationForm';

interface OwnProps {
    federation?: FederationDetailVm;
    handleClose: (drawerMode: DrawerState, id?: string) => void;
    refreshAfterSave: () => void;
}

export type Props = OwnProps & RouteComponentProps<RouteParams>;

export default withRouter(FederationForm);
